export const linkedin = {
  id: `${process.env.REACT_APP_LINKEDIN_PARTNER_ID}`
};